var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',{attrs:{"title":"SKU View"}},[_c('Header',{on:{"data":_vm.setSubmit,"export":_vm.exportData}}),_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"List"}},[_c('Table',{ref:"table"})],1),_c('vs-tab',{attrs:{"label":"Log Export"}},[_c('div',[_c('TableExport',{attrs:{"filters":_vm.filterExport}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }